var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Section",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5373",
    "data-name": "Group 5373",
    transform: "translate(-1462.874 -600.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_12",
    "data-name": "Union 12",
    d: "M3815-9798.5a3.505,3.505,0,0,1,3.5-3.5,3.507,3.507,0,0,1,3.355,2.5h7.644v2h-7.644a3.5,3.5,0,0,1-3.354,2.5A3.5,3.5,0,0,1,3815-9798.5Zm2,0a1.5,1.5,0,0,0,1.5,1.5,1.5,1.5,0,0,0,1.5-1.5,1.5,1.5,0,0,0-1.5-1.5A1.5,1.5,0,0,0,3817-9798.5Z",
    transform: "translate(-2351 10419)",
    fill: "#fea627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M0,3.5a3.5,3.5,0,0,0,6.856,1H14.5v-2H6.855A3.5,3.5,0,0,0,0,3.5Zm2,0A1.5,1.5,0,1,1,3.5,5,1.5,1.5,0,0,1,2,3.5Z",
    transform: "translate(1485.749 608.999) rotate(180)",
    fill: "#fea627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M0,3.5a3.5,3.5,0,0,0,6.856,1H14.5v-2H6.855A3.5,3.5,0,0,0,0,3.5Zm2,0A1.5,1.5,0,1,1,3.5,5,1.5,1.5,0,0,1,2,3.5Z",
    transform: "translate(1471.001 601.998) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M0,3.5a3.5,3.5,0,0,0,6.856,1H14.5v-2H6.855A3.5,3.5,0,0,0,0,3.5Zm2,0A1.5,1.5,0,1,1,3.5,5,1.5,1.5,0,0,1,2,3.5Z",
    transform: "translate(1478.748 624) rotate(-90)",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    "data-name": "Rectangle 963",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection1);
export default __webpack_public_path__ + "static/media/Section-1.c73d968b.svg";
export { ForwardRef as ReactComponent };